// import { createApp } from 'vue'
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import "element-plus/dist/index.css";
// import "@/assets/style/reset.css";
import "./styles/index.scss";
import "./styles/reset.scss";
import "./styles/gStyle/index.scss";
import components from "./common/index.js";
import { createInstance } from "@/root";

const app = createInstance(App);

app.use(store);
app.use(router);
app.use(components);
app.mount("#app");
